import { createReducer } from '@common/redux-utils';
import { StatesViewModel, OptionsViewModel } from '@models/common.models';
import {
  PurchasePartsActionType,
  SetPartsLoadingAction,
  SetPartsUSStatesAction,
  SetPartsBrandsAction,
  SetPartsEditItemAction,
  SetPartsItemTotalAction,
  SetPartsSuppliersAction,
  SetPartsStatusesAction
} from './purchase-parts.actions';
import { PurchaseRequestPartsViewModel, blankPurchaseRequestPartsVM } from '@models/PurchaseRequest';

export interface PurchasePartsState {
  readonly partsUSStates: Array<StatesViewModel>;
  readonly part: PurchaseRequestPartsViewModel;
  readonly partIndex: number;
  readonly partsLoading: boolean;
  readonly partsBrands: Array<OptionsViewModel>;
  readonly partsSuppliers: Array<OptionsViewModel>;
  readonly statuses: Array<OptionsViewModel>;
}

export const initPurchasePartsState: PurchasePartsState = {
  partsUSStates: [],
  part: blankPurchaseRequestPartsVM,
  partIndex: -1,
  partsLoading: false,
  partsBrands: [],
  partsSuppliers: [],
  statuses: []
};

function handleSetPartsUSStates(state: PurchasePartsState, action: SetPartsUSStatesAction): PurchasePartsState {
  if (!action.usStates) {
    return state;
  }
  const newPurchasePartsState = { ...state, partsUSStates: action.usStates };
  return newPurchasePartsState;
}

function handleSetPartsLoading(state: PurchasePartsState, action: SetPartsLoadingAction): PurchasePartsState {
  const newPurchasePartsState = { ...state, partsLoading: action.isLoading };
  return newPurchasePartsState;
}

function handleSetPartsBrands(state: PurchasePartsState, action: SetPartsBrandsAction): PurchasePartsState {
  if (!action.partsBrands) {
    return state;
  }
  const newPurchasePartsState = { ...state, partsBrands: action.partsBrands };
  return newPurchasePartsState;
}

function handleSetPartsSuppliers(state: PurchasePartsState, action: SetPartsSuppliersAction): PurchasePartsState {
  if (!action.partsSuppliers) {
    return state;
  }
  const newPurchasePartsState = { ...state, partsSuppliers: action.partsSuppliers };
  return newPurchasePartsState;
}

function handleSetPartsStatuses(state: PurchasePartsState, action: SetPartsStatusesAction): PurchasePartsState {
  if (!action.partsStatuses) {
    return state;
  }
  const newPurchasePartsState = { ...state, statuses: action.partsStatuses };
  return newPurchasePartsState;
}

function handleSetPartsEditItem(state: PurchasePartsState, action: SetPartsEditItemAction): PurchasePartsState {
  var newPurchasingState = {
    ...state,
    part: action.part,
    partIndex: action.index
  };
  return newPurchasingState;
}
function handleSetPartsItemTotal(state: PurchasePartsState, action: SetPartsItemTotalAction): PurchasePartsState {
  var newPurchasingState = {
    ...state,
    part: {
      ...state.part,
      quantityPartCost: action.quantityPartCost,
      estTax: action.estTax,
      total: action.total
    }
  };
  return newPurchasingState;
}

export const PartsReducer = createReducer<PurchasePartsState, PurchasePartsActionType>(initPurchasePartsState, {
  [PurchasePartsActionType.SetPartsUSStates]: handleSetPartsUSStates,
  [PurchasePartsActionType.SetPartsLoading]: handleSetPartsLoading,
  [PurchasePartsActionType.SetPartsBrands]: handleSetPartsBrands,
  [PurchasePartsActionType.SetPartsSuppliers]: handleSetPartsSuppliers,
  [PurchasePartsActionType.SetPartsStatuses]: handleSetPartsStatuses,
  [PurchasePartsActionType.SetPartsEditItem]: handleSetPartsEditItem,
  [PurchasePartsActionType.SetPartsItemTotal]: handleSetPartsItemTotal
});



// WEBPACK FOOTER //
// ./src/purchasing/purchase-parts.reducer.tsx